import React from 'react';
import { TubeRow, GapElement, PlatedSpacerBox, SpacerBox, StaticFill, SpacerRingCombo } from './primitives';

export const SideRollingStation = ({ spacers, scale, topSpacerWidth, bottomSpacerWidth, leftExtWidth, spacerAllocation, topFillRight, bottomFillRight, topFillRightWidth, bottomFillRightWidth, topLeftPad, bottomLeftPad, title }) => {
  const hasLeftLip = spacers.lipGapLeft > 0;
  const hasLips = hasLeftLip || spacers.lipGapRight > 0;
  const feedingExtra = 0.5;
  const leftIsShort = !!spacers.leftIsShort;
  const rightIsShort = !!spacers.rightIsShort;
  
  // Left gap display (0 when left side is short - skipped here)
  const displayLeftGap = !hasLips ? spacers.setupDistanceLeft + feedingExtra : spacers.setupDistanceLeft;
  const displayLeftGapWidth = displayLeftGap * scale;
  
  // Build a small note for skipped short sides
  let shortNote = '';
  if (leftIsShort && rightIsShort) shortNote = '(both sides skipped - folded at lip rolling)';
  else if (leftIsShort) shortNote = '(left side skipped - folded at lip rolling)';
  else if (rightIsShort) shortNote = '(right side skipped - folded at lip rolling)';
  
  return (
    <div className="bg-zinc-800 rounded-lg p-2 sm:p-3 border border-zinc-700 print:bg-gradient-to-br print:from-amber-50 print:to-orange-50 print:border-amber-200" style={{ overflow: 'visible' }} data-testid="side-rolling-station">
      <h3 className="font-semibold text-amber-400 mb-1 sm:mb-2 flex items-center gap-1.5 text-xs sm:text-sm print:text-amber-900">
        <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="2"/>
          <line x1="9" y1="3" x2="9" y2="21" strokeWidth="2"/>
          <line x1="15" y1="3" x2="15" y2="21" strokeWidth="2"/>
        </svg>
        {title || 'Stations 5-10 (Side Rolling)'}
        {shortNote && (
          <span className="text-[10px] sm:text-xs font-normal text-amber-300/80 print:text-amber-700" data-testid="short-side-note">
            {shortNote}
          </span>
        )}
      </h3>
      
      <div className="space-y-1 sm:space-y-2" style={{ overflow: 'visible' }}>
        {/* Top Station - plated spacer + static fill */}
        <TubeRow>
          <StaticFill width={topLeftPad} />
          <GapElement width={displayLeftGapWidth} value={displayLeftGap} />
          <PlatedSpacerBox width={topSpacerWidth} value={spacers.top_5_10} colorClass="bg-gradient-to-br from-orange-400 to-orange-500 border-orange-600" scale={scale} />
          <StaticFill width={topFillRightWidth} extra={spacers.roundedThickness - 1.0} />
        </TubeRow>

        {/* Bottom Station - regular spacer + static fill */}
        <TubeRow>
          <StaticFill width={bottomLeftPad} />
          <GapElement width={displayLeftGapWidth} value={displayLeftGap} />
          <SpacerBox width={bottomSpacerWidth} value={spacers.bottom_5_10} colorClass="bg-gradient-to-br from-teal-500 to-teal-600 border-teal-700" />
          <StaticFill width={bottomFillRightWidth} />
        </TubeRow>
        {/* Spacer ring combination */}
        <div className="flex items-center gap-2 ml-1">
          <span className="text-[10px] text-zinc-400 print:text-gray-500">Rings:</span>
          <SpacerRingCombo groups={spacerAllocation || []} />
        </div>
      </div>
    </div>
  );
};

// Lip Rolling Station (Stations 2-4)
// Right side shows fill distance (same as Side Rolling since spacer starts at same position)
